import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Types } from '@blumtechgroup/blum-ui-utils';

const _selectOrganisationUsersInitQuery = (organisationId: string) => ({
  organisations_by_pk: params(
    { id: rawString(organisationId) },
    {
      name: types.string,
    }
  ),
});

type X = Types.Unpacked<typeof _selectOrganisationUsersInitQuery>;
export type OrganisationUsersPageState = X['organisations_by_pk'];

export const selectOrganisationUsersInitQuery = (organisationId: string) =>
  gql`
    ${query(_selectOrganisationUsersInitQuery(organisationId))}
  `;
